// extracted by mini-css-extract-plugin
module.exports = {"header":"_2yyl5q7-KFNYROzcCnxB2V","gameArea":"_21gYjBOe8K6TO-KBqsPtqj"};